var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icon-css-io",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "io-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#io-a)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1024v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000063",
    d: "M1024 445.2c-11.5 7-21.3 23-51.8 23-61 0-76.2-33.9-122-33.9-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-39.6 24.2-57.9 24.2v43.7c18.3 0 27.4-24.2 57.9-24.2 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 40.3-9.6 51.8-16.5v-50.3zm0-84.9c-11.5 7-21.3 23-51.8 23-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-39.6 24.3-57.9 24.3v43.7c18.3 0 27.4-24.2 57.9-24.2 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 40.3-9.6 51.8-16.5v-50.3zm0-84.9c-11.5 7-21.3 23-51.8 23-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-39.6 24.3-57.9 24.3v43.7c18.3 0 27.4-24.2 57.9-24.2 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 40.3-9.7 51.8-16.6v-50.2zm0-85c-11.5 7-21.3 23.1-51.8 23.1-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-39.6 24.3-57.9 24.3v43.7c18.3 0 27.4-24.2 57.9-24.2 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 40.3-9.7 51.8-16.6v-50.2zm0-84.8c-11.5 6.9-21.3 23-51.8 23-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-39.6 24.2-57.9 24.2v43.8c18.3 0 27.4-24.2 57.9-24.2 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 40.3-9.7 51.8-16.6v-50.2zm0-85c-11.5 7-21.3 23.1-51.8 23.1-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34C27.4 9.7 18.3 34 0 34v43.8c18.3 0 27.4-24.2 57.9-24.2 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 40.3-9.7 51.8-16.6V20.7z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000063",
    fillRule: "evenodd",
    d: "M0 0h261.3v158H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0v17.7L232.1 158h29.2v-17.7L29.3.1H0zm261.3 0v17.7L29.3 158H0v-17.7L232.1.1h29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.9 0v158h43.5V0H109zM0 52.8v52.6h261.3V52.7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M0 63.2v31.6h261.3V63.2H0zM117.6 0v158h26.1V0h-26.1zM0 158l87.1-52.7h19.5L19.5 158H0zM0 0l87.1 52.7H67.6L0 11.8V.1zm154.7 52.7L241.8.1h19.5l-87.1 52.6h-19.5zM261.3 158l-87-52.7h19.4l67.6 40.9V158z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#a24300",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 6.9,
    d: "M815-301.2l-17.8 708.7c0 37.3 80.1 37.3 88.6 0l-17.7-708.7H815z",
    transform: "matrix(.2064 0 0 .4902 211.6 267.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 8.3,
    d: "M496 549.2l17.8 70.9 35.4-53.2-17.7 88.6 35.4-35.4-35.4 88.6 35.4-35.5-35.4 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-35.4-88.6 35.4 35.5-35.4-88.6 35.4 35.4L443 567l35.4 53.2 17.8-70.9z",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M496 549.2v496m-70.8-177l70.9 106.2 70.8-106.3",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 797.2l70.9 106.3 70.8-106.3",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 726.4l70.9 106.3 70.8-106.3",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 673.2l70.9 88.6 70.8-88.6",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 620l70.9 88.7 70.8-88.6",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M443 567l53 106.2L549.3 567",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 8.3,
    d: "M496 549.2l17.8 70.9 35.4-53.2-17.7 88.6 35.4-35.4-35.4 88.6 35.4-35.5-35.4 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-35.4-88.6 35.4 35.5-35.4-88.6 35.4 35.4L443 567l35.4 53.2 17.8-70.9z",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M496 549.2v496m-70.8-177l70.9 106.2 70.8-106.3",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 797.2l70.9 106.3 70.8-106.3",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 726.4l70.9 106.3 70.8-106.3",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 673.2l70.9 88.6 70.8-88.6",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 620l70.9 88.7 70.8-88.6",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M443 567l53 106.2L549.3 567",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 8.3,
    d: "M496 549.2l17.8 70.9 35.4-53.2-17.7 88.6 35.4-35.4-35.4 88.6 35.4-35.5-35.4 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-35.4-88.6 35.4 35.5-35.4-88.6 35.4 35.4L443 567l35.4 53.2 17.8-70.9z",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M496 549.2v496m-70.8-177l70.9 106.2 70.8-106.3",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 797.2l70.9 106.3 70.8-106.3",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 726.4l70.9 106.3 70.8-106.3",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 673.2l70.9 88.6 70.8-88.6",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 620l70.9 88.7 70.8-88.6",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M443 567l53 106.2L549.3 567",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 8.3,
    d: "M496 549.2l17.8 70.9 35.4-53.2-17.7 88.6 35.4-35.4-35.4 88.6 35.4-35.5-35.4 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-35.4-88.6 35.4 35.5-35.4-88.6 35.4 35.4L443 567l35.4 53.2 17.8-70.9z",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M496 549.2v496m-70.8-177l70.9 106.2 70.8-106.3",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 797.2l70.9 106.3 70.8-106.3",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 726.4l70.9 106.3 70.8-106.3",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 673.2l70.9 88.6 70.8-88.6",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 620l70.9 88.7 70.8-88.6",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M443 567l53 106.2L549.3 567",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 8.3,
    d: "M496 549.2l17.8 70.9 35.4-53.2-17.7 88.6 35.4-35.4-35.4 88.6 35.4-35.5-35.4 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-35.4-88.6 35.4 35.5-35.4-88.6 35.4 35.4L443 567l35.4 53.2 17.8-70.9z",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M496 549.2v496m-70.8-177l70.9 106.2 70.8-106.3",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 797.2l70.9 106.3 70.8-106.3",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 726.4l70.9 106.3 70.8-106.3",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 673.2l70.9 88.6 70.8-88.6",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 620l70.9 88.7 70.8-88.6",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M443 567l53 106.2L549.3 567",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 8.3,
    d: "M460.6 549.2l28.7 70.9 42.2-53.2-10.2 88.6 28-35.4-17.8 88.6 25.2-35.5-25.2 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-45.6-88.6 45.6 35.5-53.1-88.6 43 35.4-25.3-88.6 35.4 53.2v-70.9z",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M467.2 584.6l28.9 124v336.7",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M436.2 885.8l59.9 88.6 60.6-88.6",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M434.5 815l61.6 88.5 60.6-88.5",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M435.4 744.1l60.7 88.6 59.8-88.6",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M432.8 691l63.3 70.8 53.1-70.9",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 637.8l70.9 70.9 45.4-70.9",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M436.1 593.2l53.2 87 35.3-95.6",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 8.3,
    d: "M460.6 549.2l28.7 70.9 42.2-53.2-10.2 88.6 28-35.4-17.8 88.6 25.2-35.5-25.2 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-45.6-88.6 45.6 35.5-53.1-88.6 43 35.4-25.3-88.6 35.4 53.2v-70.9z",
    transform: "matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M467.2 584.6l28.9 124v336.7",
    transform: "matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M436.2 885.8l59.9 88.6 60.6-88.6",
    transform: "matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M434.5 815l61.6 88.5 60.6-88.5",
    transform: "matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M435.4 744.1l60.7 88.6 59.8-88.6",
    transform: "matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M432.8 691l63.3 70.8 53.1-70.9",
    transform: "matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 637.8l70.9 70.9 45.4-70.9",
    transform: "matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M436.1 593.2l53.2 87 35.3-95.6",
    transform: "matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006d00",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 8.3,
    d: "M354.3 531.5l88.6 88.6 17.7-53.2v88.6l35.5-35.4-17.8 88.6 35.5-35.5-17.7 88.6 35.4-35.4-17.7 106.3 35.4-35.4-35.4 106.3 35.4-35.5-17.7 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-53.1-82.3 35.4 11.5-35.4-106.3 35.4 35.4-53.1-106.3 35.4 35.4-53.2-88.6 53.2 35.5-70.9-88.6 53.2 35.4-70.9-70.8 70.9 35.4-53.2-88.6z",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M379 560l64 95.5 17.6 53.2 8.9 45.2 8.8 78.8 9.4 70.9 8.4 141.7",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M425.2 903.5l63.7 71 50.7-88.7",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M417 815l70.7 88.5 50.7-88.5",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M407.5 752.4l70.9 80.3 45.9-88.6M372.1 637.8l88.5 70.9 25.9-70.9",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M360.6 602.4l82.3 53.1 10.5-53.1m-63.6 88.5l81 71 34-71",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M541.5 1173.3l-1.7-229.1-61.1-107c-15.3-52.6-7.8-78 17-79.8 24.7-1.6 49.2 13.6 84.8 15.3 35.6 1.7 28.9-59.4 81.5-57.7 52.6 1.7 144.3 32.3 222.3 37.4 78.1 5 118.8-27.2 208.8-30.6 90-3.4 113.7 42.4 118.8 42.4s30.6-18.6 56-22c25.5-3.4 34 10.2 34 10.2s-1.7 57.7-13.6 91.6c-11.9 34-54.3 90-56 90-1.7 0-15.3 249.5-15.3 251.2 0 1.7-675.5-6.8-675.5-11.9z",
    transform: "matrix(.13659 0 0 .12573 266.4 208.2)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    d: "M531.5 584.6s-68-52-69.8-177.1c-1-72 34.4-124 123-124 124 0 301.1 53.1 301.1 53.1v17.7s-141.7-53.1-301.2-53.1c-70.8 0-106.3 52-106.3 105.2 0 88.6 71 178.3 71 178.3v141.7h-17.8V584.6z",
    transform: "matrix(-.13659 0 0 .12573 508.4 252.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 506.2 252.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 508.6 247.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 509.9 242.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 510.8 236.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 510.6 230.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 502.7 257)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 508.5 225)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 504 220.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 498 217.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 492 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 485.5 217.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 479 218.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 472.6 219)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 465.6 220)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(-.13659 0 0 .12573 459.6 221.6)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 268.6 252.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 266.1 247.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 264.9 242.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 264 236.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 264.2 230.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 266.2 225)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 270.6 220.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 276.7 217.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 282.7 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 289.2 217.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 295.7 218.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 302.2 219)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 309.1 220)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 315.1 221.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 272 257)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M531.5 584.6s-68-52-69.8-177.1c-1-72 34.4-124 123-124 124 0 301.1 53.1 301.1 53.1v17.7s-141.7-53.1-301.2-53.1c-70.8 0-106.3 52-106.3 105.2 0 88.6 71 178.3 71 178.3v141.7h-17.8V584.6z",
    transform: "matrix(.13659 0 0 .12573 266.4 252.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: 3,
    d: "M1240.2 531.5s15.3-35.4 70.9-35.4c37.8 0 70.8 35.4 70.8 70.8v70.9h35.5v-70.9c0-35.4 35.4-70.8 70.8-70.8 53.2 0 70.9 35.4 70.9 35.4s0-106.3-70.9-106.3c-53.1 0-70.8 35.4-70.8 35.4s17.7-53.1 17.7-106.3-35.4-88.6-35.4-88.6c0 6.8-35.5 35.5-35.5 88.6s17.7 106.3 17.7 106.3-17.7-35.4-70.8-35.4c-70.9 0-70.9 106.3-70.9 106.3z",
    transform: "matrix(.04553 0 0 .0479 299.4 309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: 3,
    d: "M1240.2 531.5s15.3-35.4 70.9-35.4c37.8 0 70.8 35.4 70.8 70.8v70.9h35.5v-70.9c0-35.4 35.4-70.8 70.8-70.8 53.2 0 70.9 35.4 70.9 35.4s0-106.3-70.9-106.3c-53.1 0-70.8 35.4-70.8 35.4s17.7-53.1 17.7-106.3-35.4-88.6-35.4-88.6c0 6.8-35.5 35.5-35.5 88.6s17.7 106.3 17.7 106.3-17.7-35.4-70.8-35.4c-70.9 0-70.9 106.3-70.9 106.3z",
    transform: "matrix(.04553 0 0 .0479 347.8 309)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M531.5 832.7V673.2s35.4 53.2 88.6 53.2c43.5 0 88.6-70.9 88.6-70.9s41.5 53.2 88.6 53.2c42 0 88.5-68.6 88.5-68.6s43.2 68.6 88.6 68.6c45.5 0 88.6-53.2 88.6-53.2s46.3 70.9 106.3 70.9c53.1 0 70.9-53.2 70.9-53.2v159.5H531.5z",
    transform: "matrix(.13659 0 0 .12573 266.4 252.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M708.7 832.7v-124S815 744 815 832.7H708.7z",
    transform: "matrix(.13659 0 0 .12573 242.2 252.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M708.7 832.7v-124S815 744 815 832.7H708.7z",
    transform: "matrix(-.13659 0 0 .12573 532.5 252.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M602.4 832.7C602.4 744 708.7 688 708.7 688S815 744 815 832.7H602.4z",
    transform: "matrix(.13659 0 0 .12573 266.4 252.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M602.4 832.7C602.4 744 708.7 688 708.7 688S815 744 815 832.7H602.4z",
    transform: "matrix(.13659 0 0 .12573 314.8 252.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M584.6 847.5c0-88.6 124.1-159.4 124.1-159.4s124 70.8 124 159.4h-248z",
    transform: "matrix(.13659 0 0 .12573 290.6 250.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M1275.6 655.5c-35.4-17.7-166-35.4-376.3-35.4s-350 17.7-385.5 35.4c-35.4 17.7-35.4 53.2 0 70.9 35.4 17.7 175.3 35.4 385.5 35.4s340.9-17.7 376.3-35.4c35.4-17.7 35.4-53.2 0-70.9z",
    transform: "matrix(.13505 0 0 .12573 265.9 275)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M435.8 366.3c0 4.5-40.3 4.5-48.4 4.5-8.8 0-48.4 1.2-48.4-4.5 0-4.4 39.9-4.4 48.4-4.4 8.4 0 48.4.9 48.4 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M343.8 350.3c0 1.5-1 2.7-2.4 2.7s-2.4-1.2-2.4-2.7 1-2.6 2.4-2.6c1.3 0 2.4 1.2 2.4 2.6zm92 0c0 1.5-1.1 2.7-2.5 2.7-1.3 0-2.4-1.2-2.4-2.7s1.1-2.6 2.4-2.6c1.4 0 2.4 1.2 2.4 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.2 349c0 1.4-2.2 2.6-4.8 2.6s-4.9-1.2-4.9-2.7 2.2-2.6 4.9-2.6 4.8 1.2 4.8 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006300",
    d: "M415.4 349c0 1.4-1.6 2.6-3.6 2.6s-3.6-1.2-3.6-2.7 1.6-2.6 3.6-2.6 3.6 1.2 3.6 2.6zm-49.8 0c0 1.4-1.6 2.6-3.6 2.6s-3.7-1.2-3.7-2.7 1.6-2.6 3.7-2.6c2 0 3.6 1.2 3.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M1257.9 496s35.4-53 70.9-53h35.4v35.3c0 53.2-53.1 71-53.1 71h141.7s-53.2-17.8-53.2-71V443h35.5c35.4 0 70.8 53.2 70.8 53.2V354.3s-35.4 53.2-70.8 53.2h-35.5V372c0-53.1 53.2-70.8 53.2-70.8H1311s53.1 17.7 53.1 70.8v35.5h-35.4c-35.5 0-70.9-53.2-70.9-53.2v141.8z",
    transform: "matrix(.07805 0 0 .07185 279.5 298)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: 3.3,
    d: "M1381.9 549.2h70.9s-53.2-17.7-53.2-70.9V443h35.4c35.5 0 71 53.2 71 53.2V354.3s-35.5 53.2-71 53.2h-35.4V372c0-53.1 53.2-70.8 53.2-70.8h-70.9v248z",
    transform: "matrix(.03903 0 0 .06287 285 307.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: 3.3,
    d: "M1381.9 549.2h70.9s-53.2-17.7-53.2-70.9V443h35.4c35.5 0 71 53.2 71 53.2V354.3s-35.5 53.2-71 53.2h-35.4V372c0-53.1 53.2-70.8 53.2-70.8h-70.9v248z",
    transform: "matrix(-.03903 0 0 .06287 489.7 307.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M903.5 602.4a17.7 17.7 0 11-35.4 0 17.7 17.7 0 0135.4 0z",
    transform: "matrix(.13659 0 0 .12573 266.4 252.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: 2.2,
    d: "M1257.9 496s35.4-53 70.9-53h35.4v35.3c0 53.2-53.1 71-53.1 71h141.7s-53.2-17.8-53.2-71V443h35.5c35.4 0 70.8 53.2 70.8 53.2V354.3s-35.4 53.2-70.8 53.2h-35.5V372c0-53.1 53.2-70.8 53.2-70.8H1311s53.1 17.7 53.1 70.8v35.5h-35.4c-35.5 0-70.9-53.2-70.9-53.2v141.8z",
    transform: "matrix(.07805 0 0 .07185 279.5 251.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M903.5 602.4a17.7 17.7 0 11-35.4 0 17.7 17.7 0 0135.4 0z",
    transform: "matrix(.13659 0 0 .12573 266.6 206.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M850.4 655.5h70.9v53.2h-71z",
    transform: "matrix(.13659 0 0 .12573 266.4 208.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff100",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M850.4 683.3h70.9v202.5h-71z",
    transform: "matrix(.13659 0 0 .12573 266.4 208.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 324.4 246)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 324.4 240.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 324.4 235)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M478.4 549.2a17.7 17.7 0 11-35.5 0 17.7 17.7 0 0135.5 0z",
    transform: "matrix(.13659 0 0 .12573 324.4 229.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5 357.5c0 1-2.2 1.8-5 1.8s-4.8-.8-4.8-1.8 2.2-1.8 4.9-1.8 4.9.8 4.9 1.8zm44.6 4.4c-.3.7-2.7.8-5.4.1-2.7-.6-4.6-1.6-4.4-2.3.3-.7 2.7-.8 5.4-.1 2.7.6 4.6 1.6 4.4 2.3zm-18.7-3c0 .9-2.4 1.4-5.2 1.3-2.7-.2-4.9-1.1-4.8-2 .1-.9 2.5-1.4 5.2-1.2 2.8.2 5 1 4.8 1.9zm-81.8 3c.2.7 2.6.8 5.3.1 2.7-.6 4.7-1.6 4.4-2.3-.3-.7-2.7-.8-5.4-.1-2.6.6-4.6 1.6-4.3 2.3zm19.5-3.4c.1.9 2.5 1.4 5.2 1.2 2.8-.2 5-1 4.8-2 0-.8-2.4-1.4-5.2-1.2-2.7.2-4.9 1-4.8 2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIo);
export default __webpack_public_path__ + "static/media/io.bc28ce226e5406e0cb38d789d1863264.svg";
export { ForwardRef as ReactComponent };